// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-error2-page',
    computed: {
        errorMessage() {
            //Vars
            let tMessage = this.$route.query.m;
            //Check
            if (!tMessage) {
                return { errorMessage: 'Unknown Error.' };
            }
            return JSON.parse(utils.decodeBase64(decodeURI(tMessage)));
        },
    },
    methods: {
        onBack() {
            this.$router.push('/login');
        },
    }
});
// #endregion
